/* eslint-disable no-nested-ternary */
// Package Imports
import { Card, Row, Col, Divider } from 'antd';
import useFormatCurrency from 'core/utils/formatCurrency';
import dayjs from 'dayjs';

// Project Imports

const WinningsCard = ({ record, headers }) => {
  const formatCurrency = useFormatCurrency();
  const renderCellValue = (item, recordData) => {
    const text = recordData[item.key];
    if (item.data_type === 'date') {
      const formattedDateRange = dayjs(text).format('MMM DD, YYYY');
      if (text) {
        return formattedDateRange;
      }
    }
    if (item.data_type === 'currency') {
      return formatCurrency(text);
    }
    return text;
  };

  return (
    <Card className="task-card cursor-pointer">
      {/* <Row justify="space-between" align="middle">
        <Col> */}
      <span className="dashboard-card-field-label">Name : </span>
      <span className="dashboard-card-field-value">{record?.name}</span>
      {/* </Col>
      </Row> */}
      <Divider className="mt-sm mb-sm" />
      <Row gutter={[16, 16]}>
        {headers
          ?.filter(
            (item) => item.key?.toLowerCase().replace(/[\s_]+/g, '') !== 'name'
          )
          .map((item) => (
            <Col key={item.key} xs={24} sm={12} md={8}>
              <span className="dashboard-card-field-label">{item.label}</span>

              <div className="dashboard-card-field-value">
                {renderCellValue(item, record)}
              </div>
            </Col>
          ))}
      </Row>

      <div className="divider" />
    </Card>
  );
};

export default WinningsCard;
